module.exports = __webpack_public_path__ + "static/media/mySQL.98880cf1.png";